'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function GFFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-uuztbksm0", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-uuztbksm0)" }, /* @__PURE__ */ React.createElement("rect", { width: "32", height: "24", fill: "#5eaa22", rx: "2" }), /* @__PURE__ */ React.createElement("path", { fill: "#feca00", d: "M0 0l32 24H0z" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#e21835",
        d: "M15.93 14.406l-3.485 2.418 1.114-4.141L11 10.038l3.465-.143L15.93 5.8l1.466 4.095h3.458l-2.553 2.788 1.279 3.897z"
      }
    )))
  );
}

export { GFFlag };
//# sourceMappingURL=GF.mjs.map
